import type { WhatsNew } from '../Types/WhatsNew.types';
import type { WhatsNewFormData, WhatsNewFormItem } from '../Types/WhatsNewForm.types';

/**
 * Maps a WhatsNew API response object into a WhatsNewFormData for the form.
 * Seeds the creation flow when it opens in edit mode.
 */
export function mapWhatsNewToFormData(whatsNew: WhatsNew): WhatsNewFormData {
  // Build welcome message translations
  const welcomeMessage = {
    pt:
      whatsNew.translations.find(t => t.language === 'pt')?.welcomeMessage ||
      whatsNew.welcomeMessage,
    en:
      whatsNew.translations.find(t => t.language === 'en')?.welcomeMessage ||
      whatsNew.welcomeMessage,
    es:
      whatsNew.translations.find(t => t.language === 'es')?.welcomeMessage ||
      whatsNew.welcomeMessage,
  };

  // Build subtitle translations
  const subtitle = {
    pt: whatsNew.translations.find(t => t.language === 'pt')?.subtitle || whatsNew.subtitle || '',
    en: whatsNew.translations.find(t => t.language === 'en')?.subtitle || whatsNew.subtitle || '',
    es: whatsNew.translations.find(t => t.language === 'es')?.subtitle || whatsNew.subtitle || '',
  };

  // Build footer translations
  const footer = {
    pt: whatsNew.translations.find(t => t.language === 'pt')?.footer || whatsNew.footer || '',
    en: whatsNew.translations.find(t => t.language === 'en')?.footer || whatsNew.footer || '',
    es: whatsNew.translations.find(t => t.language === 'es')?.footer || whatsNew.footer || '',
  };

  // Build confirmButtonText translations
  const confirmButtonText = {
    pt:
      whatsNew.translations.find(t => t.language === 'pt')?.confirmButtonText ||
      whatsNew.confirmButtonText ||
      '',
    en:
      whatsNew.translations.find(t => t.language === 'en')?.confirmButtonText ||
      whatsNew.confirmButtonText ||
      '',
    es:
      whatsNew.translations.find(t => t.language === 'es')?.confirmButtonText ||
      whatsNew.confirmButtonText ||
      '',
  };

  // Build items with translations
  const items: WhatsNewFormItem[] = whatsNew.items.map(item => ({
    icon: item.icon,
    title: item.title,
    body: item.body,
    color: item.color,
    order: item.order,
    privileges: item.privileges ?? [],
    translations: {
      pt: {
        title: item.translations.find(t => t.language === 'pt')?.title || item.title,
        body: item.translations.find(t => t.language === 'pt')?.body || item.body,
      },
      en: {
        title: item.translations.find(t => t.language === 'en')?.title || item.title,
        body: item.translations.find(t => t.language === 'en')?.body || item.body,
      },
      es: {
        title: item.translations.find(t => t.language === 'es')?.title || item.title,
        body: item.translations.find(t => t.language === 'es')?.body || item.body,
      },
    },
  }));

  return {
    platformVersionId: whatsNew.platformVersion.id,
    welcomeMessage,
    subtitle,
    footer,
    confirmButtonText,
    tenantSlug: whatsNew.tenantSlug,
    publishedAt: whatsNew.publishedAt || new Date().toISOString(),
    pageId: whatsNew.pageId ?? undefined,
    actionParams: whatsNew.actionParams ?? undefined,
    items,
  };
}
